export const ICON_SIZE = 20;
export const HEADING_GAP = 8;
